import { Injectable } from "@angular/core";
import { timer } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class Step2Service {


    async load(type: number): Promise<Array<string>> {
        return timer(0).pipe(
            map(()=>{
                if (type===1) {
                    return ['A1','A2'];
                } else if (type===2) {
                    return ['B1','B2','B3']
                }
                return []
            })
        ).toPromise()
    } 
}